import React from 'react';
import "./Home/css/customModal.css";

function CustomModal({ showModal, toggleModalView, children, isfromEmi=false, }) {
    return showModal ? (
      <>
        <div className="backdrop" onClick={toggleModalView}></div>

        <div
          // className="custom-modal-container"
          className={`${
                  isfromEmi
                    ? "custom-box"
                    : "custom-modal-container"
                }`}
        >
          <div className="close-modal" style={{textAlign:'right'}}>
            <button className="close-modal" onClick={toggleModalView} style={{border: "none"}}>
              <i style={{color: "#fff" , background:'#000' , padding:'0.6rem'}} className="fa fa-times mb-0"></i>
            </button>
          </div>

          <div className="modal-conten" style={{fontWeight: "500"}}>
           {children}
          </div>
        </div>
      </>
    ) : null;
}

export default CustomModal;